import { Flex } from '@radix-ui/themes'

import React, { useCallback } from 'react'
import { useDispatch } from 'hooks/use-redux'
import {
  removeGroupBusinessInvite,
  resendGroupBusinessInvite,
} from '@disco/state-management/actions/GroupActions'
import { SharePartnerDisco } from 'components/common/share-partner-disco'
import { ShareOtherDiscosTable } from 'components/share/share-other-discos-table'
import LoadingIndicator from 'components/ui/loading-indicator'
import { extractSubdomain, useLoadBusinesses } from './utils'
type Props = {
  channelId: number
}
export const ShareOtherDiscoTab = ({ channelId }: Props): React.ReactNode => {
  const dispatch = useDispatch()
  const { businessInvites, isLoading } = useLoadBusinesses(channelId)
  const handleResendInvite = useCallback(
    async domain => {
      if (!domain) return
      const subdomain = extractSubdomain(domain)
      await dispatch(resendGroupBusinessInvite(channelId, subdomain))
    },
    [channelId],
  )
  const handleRemoveInvite = useCallback(
    async (inviteId, domain) => {
      if (!inviteId || !domain) return
      await dispatch(removeGroupBusinessInvite(channelId, inviteId, domain))
    },
    [channelId, dispatch],
  )
  return (
    <Flex direction="column" width="100%" gap="2">
      {isLoading ? (
        <Flex width="100%" justify="center" pt="24px">
          <LoadingIndicator />
        </Flex>
      ) : (
        <>
          <SharePartnerDisco channelId={channelId} />
          <ShareOtherDiscosTable
            businesses={businessInvites}
            onResendInvite={handleResendInvite}
            onRemove={handleRemoveInvite}
          />
        </>
      )}
    </Flex>
  )
}
